<template>
    <div v-show="show" :style="{ 'z-index': (currentZIndex-1)}">
        <div :style="{ 'z-index': (currentZIndex)}"
        class="dimmed_black" style="top:0;display:block;"></div>
        <div class="rew19_popContainer big" id="pop_paymentinfo" style="display:block;">
            <div class="rew19_popup_wrap">
            <h2>
                <span class="rew19_basketList_tit">제품명세 및 수령증 변경</span>
                <button class="rew19_basketList_btn" @click="onCancel"><span>닫기</span></button>
            </h2>
            </div>
            <div class="rew19_popup_cont">
                <dl class="rew19_select_table">
                    <dt>
                        <span class="rew19_table_tit">제품명세 및 수령증 종류 선택</span>
                    </dt>
                    <dd class="rew19_payment_container rew19_payment_lineup">
                        <ul class="rew19_clear">
                            <li class="rew19_wrapRadio_t1 rew19_lineup_left">
                            <input
                                type="radio"
                                class="rew19_fakeRadio_t1"
                                id="fake-radio_receipt01"
                                value="Y"
                                v-model="viewData.wholesale_receipt"
                            />
                            <label for="fake-radio_receipt01">
                              도매용
                            </label>
                            </li>
                            <li class="rew19_wrapRadio_t1 rew19_lineup_left">
                            <input
                                type="radio"
                                class="rew19_fakeRadio_t1"
                                id="fake-radio_receipt02"
                                value="N"
                                v-model="viewData.wholesale_receipt"
                            />
                            <label for="fake-radio_receipt02">
                              소매용
                            </label>
                        </li></ul>
                    </dd>
                    <dd class="rew19_pDetail">
                        <ul class="rew19_dotList">
                            <li>부가가치세 매입세액 공제 및 증빙용 세금계산서 발급을 원하시는 경우, <b>결제 전에 반드시 본인 명의의 사업자등록증</b>을 당사에 제출해주시기 바랍니다.</li>
                            <li>사업자등록증에 기재된 <b>대표자 성명과 회원(주문자)의 명의가 일치해야 하며</b>, 불일치할 경우 사업자등록 및 세금계산서 발급이 불가합니다. 사업자등록증 제출은 <b>회원정보와 함께 아래 이메일 주소로 보내주시기 바랍니다.</b> <br/>
                              <a href="mailto:ds_kr@nuskin.com">📧 ds_kr@nuskin.com</a>
                            </li>
                        </ul>
                    </dd>
                </dl>
            </div><!--//rew19_popup_cont-->

            <div class="rew19_popup_btn rew19_clear">
                <button class="rew19_popHarf disabled" @click="onCancel">취소</button>
                <button class="rew19_popHarf activation" @click="onOk">확인</button>
            </div>
        </div>
    </div>
</template>
<script>
import * as ErrMsg from "@/utils/error_msg";

export default {
  name: 'ChangeReceiptDialog',
  components: {},
  props: {
    show: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      currentZIndex : 2000,
      viewData: {}
    }
  },
  watch: {
    show(show) {
      this.$modalAfterTreat(show);

      show && this.$nextTick(() => {
        let _this = this;
        _this.currentZIndex = _this.$getDimmMaxIndex() + 2;

        this.$el.focus();
      })
    }
  },
  updated: function () {
    this.$nextTick(function () {
      $(".rew19_popContainer.big .rew19_popup_cont").css('height', $(window).height() - 102);
    })
  },
  mounted() {
    let _this = this;
  },
  methods :{
    onClose(response) {
      let _this = this;

      _this.$emit('close', response, response ? _this.viewData : null);
    },
    onCancel(){
      this.onClose(false);
    },
    onOk() {
      this.onClose(true);
    },

    /**
     * API Request
     */


    /**
     * Local
     */
    initData : function(data){
      let _this = this;

      _this.viewData = {
        ..._this.viewData,
        ...data
      };
    },
  }
}
</script>



// WEBPACK FOOTER //
// src/components/popup/changeReceiptDialog.vue